export default __webpack_public_path__ + "static/media/2012.bfc4eaea.jpg";